/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".profile-picture[_ngcontent-%COMP%]{width:7em;height:7em;-o-object-fit:cover;object-fit:cover;border-radius:50%}"];
export { styles as styles };
